module.exports = __webpack_public_path__ + "static/img/award3_active.7b3c93c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award3_active.png
// module id = JA1P
// module chunks = 7